import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import CompleteInformationMx from "./CompleteInformationMx";
import CompleteInformationCol from "./CompleteInformationCol";
import CompleteInformationBr from "./CompleteInformationBr";
import CompleteInformationOther from "./CompleteInformationOther";
import { LangContext } from "../LangContext.jsx";
class CompleteInformation extends Component {
    constructor(props) {
        super();
        this.state = {
            rfc:'',
            countries: [],
            selectedCountry: 1,
            countryReadOnly:false,
        };
        this.changeCountry = this.changeCountry.bind(this);
    }
    componentDidMount() {
        this.getCountries()
    }
    async getCountries() {
        const res = await axios.get('/api/countries')
        const data = res.data
        const options = data.map(c => ({
            "value" : c.id,
            "label" : c.name
        }))
        this.setState({countries: options},function(){
            if(this.props.countryid != ''){
                this.setState({selectedCountry: this.props.countryid})
                this.setState({countryReadOnly: true})
            }
        })
    }

    changeCountry(event) {
        this.setState({country: event.target.value})
        this.setState({selectedCountry: event.target.value})
	}

    render() {
        const { countries } = this.state
        return (
            <>
                <div className="col-sm-6 justify-content-center text-left form-group"> 
                    <label className="text-left font-weight-bold text-dark-light">{this.props.country_label}</label>
                    <select  disabled={this.state.countryReadOnly}  id={this.props.country} name={this.props.country} placeholder={this.props.country} value={this.state.selectedCountry} onChange={this.changeCountry} className="form-control form-control-solid">
                        <option value="0">--Seleccionar--</option>
                        {this.state.countries.map((o, i) => {
                            return <option key={i} value={o.value}>{o.label} {this.props.country_name !== "" ? `(${this.props.country_name})` : ""} </option>;
                        })}
                    </select>
                </div>  
                {this.props.countryid != "" ? (
                    <>
                        {this.props.countryid == 1 && (
                            <CompleteInformationMx peopleId={this.props.peopleid} rfc={this.props.rfc} internalid={this.props.internalid} fiscalName={this.props.fiscalname} route={this.props.route} personType={this.props.persontype} />
                        )}
                        {this.props.countryid == 2 && (
                            <CompleteInformationCol peopleId={this.props.peopleid} rfc={this.props.rfc} internalid={this.props.internalid} fiscalName={this.props.fiscalname} route={this.props.route} personType={this.props.persontype} />
                        )}
                        {this.props.countryid == 3 && (
                            <CompleteInformationBr peopleId={this.props.peopleid} rfc={this.props.rfc} internalid={this.props.internalid} fiscalName={this.props.fiscalname} route={this.props.route} personType={this.props.persontype} />
                        )}
                        {this.props.countryid == 4 && (
                            <CompleteInformationOther peopleId={this.props.peopleid} rfc={this.props.rfc} internalid={this.props.internalid} fiscalName={this.props.fiscalname} route={this.props.route} personType={this.props.persontype} />
                        )}
                    </>
                ) : (
                <>
                    {this.state.selectedCountry == '1' && (
                        <CompleteInformationMx rfc={this.props.rfc} internalid={this.props.internalid} route={this.props.route} fiscalName={this.props.fiscalname} personType={this.props.persontype} />
                    )}
                    {this.state.selectedCountry == '2' && (
                        <>
                            <CompleteInformationCol rfc={this.props.rfc} internalid={this.props.internalid} route={this.props.route} fiscalName={this.props.fiscalname} personType={this.props.persontype} />
                        </>
                    )}
                    {this.state.selectedCountry == '3' && (
                        <CompleteInformationBr rfc={this.props.rfc} internalid={this.props.internalid} route={this.props.route} fiscalName={this.props.fiscalname} personType={this.props.persontype} />
                    )}
                    {this.state.selectedCountry == '4' && (
                        <CompleteInformationOther rfc={this.props.rfc} internalid={this.props.internalid} route={this.props.route} fiscalName={this.props.fiscalname} personType={this.props.persontype} />
                    )}
                </>
                )}
            </>
        );
    }
}

export default CompleteInformation;

if (document.getElementById('CompleteInformation')) {
    ReactDOM.render(<CompleteInformation />, document.getElementById('CompleteInformation'));
}
